import { EligibilityOption } from './types';

export const ELIGIBILITY_LABELS: {[key in EligibilityOption]: string} = {
	[EligibilityOption.notEligible]: $.__('Not Eligible'),
	[EligibilityOption.eligible]: $.__('Eligible'),
};
